module.exports = __webpack_public_path__ + "static/media/map-first-floor.21362a48.png";